export default "__VITE_ASSET__7a936947__"